const optionsDate = { day: '2-digit', month: 'long', year: 'numeric' };
const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: true };


export function dateFormatWithTime(date) {
    if (!date) return '';
    const formattedDate = new Intl.DateTimeFormat('en-US', optionsDate).format(new Date(date));
    const formattedTime = new Intl.DateTimeFormat('en-US', optionsTime).format(new Date(date));
    return `${formattedDate}, ${formattedTime}`;
}

export const formatDate = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
};

export const financialYearOptions = [
    { value: 'lastOneWeek', label: 'Last One Week' },
    { value: 'last15Days', label: 'Last 15 Days' },
    { value: 'currentMonth', label: 'Current Month' },
    { value: 'lastMonth', label: 'Last Month' },
    { value: 'last3Months', label: 'Last 3 Months' },
    { value: 'last6Months', label: 'Last 6 Months' },
    { value: 'currentFinancialYear', label: 'Current Financial Year' },
    { value: 'lastFinancialYear', label: 'Last Financial Year' },
    { value: 'custom', label: 'Select Date Renge' },
];
export const getFirstDayOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1);
export const getLastDayOfMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);
